/**
 * KOSHA GUIDE C-C-18-2026(舊 D-59-2020) Brzustowski-Sommer 법 — 화염 중심
 * 위치(yc·xc) 노모그래프 디지털화 데이터 로더.
 *
 * 원본: /data/kosha-flare-bs.json. 디지털화 방법·정확도 한계는 그 파일의
 * $comment/digitizationMethod/accuracyNote 참고 — 근사치이며 djR 75~150
 * 구간은 오차가 더 크다. `data/verify-kosha-flare-bs.py` 가 실제 프로젝트
 * 파일에서 가져온 검증 사례로 대조한다.
 */
import raw from "../../data/kosha-flare-bs.json";

/** djR 선 위의 실측점 하나(CL, 값). */
export interface BsSample {
  readonly cl: number;
  readonly v: number;
}

export interface BsCurvePoint {
  readonly djR: number;
  /** CL 오름차순. 1개면 exponent(선 고유 또는 테이블 공통)로 단일 거듭제곱식을,
   * 2개 이상이면 인접 샘플 사이를 조각별 거듭제곱으로 잇는다. */
  readonly samples: readonly BsSample[];
  /** samples 가 1개일 때만 쓰는, 이 선 고유의 CL 방향 거듭제곱 지수. 없으면 테이블 공통값. */
  readonly exponent?: number;
}

export interface BsCurveTable {
  readonly exponent: number;
  readonly points: readonly BsCurvePoint[];
}

export const YC_TABLE: BsCurveTable = raw.ycTable;
export const XC_TABLE: BsCurveTable = raw.xcTable;

export interface BsValidationCase {
  readonly label: string;
  readonly cl: number;
  readonly djR: number;
  readonly ycM: number;
  readonly xcM: number;
}

export const VALIDATION_CASES: readonly BsValidationCase[] = raw.validationCases.cases;
